import { http, http_main } from '@/environment/environment';

class TransactionService
{
    getTransactionsList(walletAddress: string, network: string): Promise<any> {
        if(network=='testnet'){
            return http.get(`wallets/${walletAddress}/transactions`);
        }else{
            return http_main.get(`wallets/${walletAddress}/transactions`);
        }
    }


    getTransactionType(transactionType: string): string {
        const transactionArr = transactionType.split("_");

        for (let x = 0; x < transactionArr.length; x++) {
            transactionArr[x] = transactionArr[x].charAt(0).toUpperCase() + transactionArr[x].slice(1).toLowerCase();
        }

        return transactionArr.join(" ");
    }
}

export default new TransactionService();